/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { PropertyValueResource } from "@octopusdeploy/octopus-server-client";
import { isString } from "lodash";
const isBound = (value: PropertyValueResource, fallback = true) => {
    if (value) {
        return (value as string).includes("#{");
    }
    return fallback;
};
const bindingPattern = /^#{(.+)}$/;
export const isBoundRegex = (value: PropertyValueResource, fallback = true) => {
    if (isString(value)) {
        return bindingPattern.test(value);
    }
    return fallback;
};
export default isBound;
